/**
 * 商品マスタプルーフ帳票出力用VO
 *
 * @export KYMW4200OutputModel
 * @class KYMW4200OutputModel
 */
export class KYMW4200OutputModel {

  public PCode: string = <string>'';

  public ItemCode = '';

}
